import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setShowErrorMessagePopup, setErrorResponse } from '../actions/localStates';

import ClientsContainer from '../containers/ClientsContainer';
import UsersContainer from '../containers/UsersContainer';
import TokensSearchContainer from '../containers/TokensSearchContainer';
import ConfigContainer from '../containers/ConfigContainer';
import BreadcrumbsContainer from '../containers/BreadcrumbsContainer'
import SessionEndPopup from './SessionEndPopup'
import ErrorMessagePopup from './ErrorMessagePopup'
import ActionResultInfoPopup from './ActionResultInfoPopup'

const activeElementsArray = [<UsersContainer />, <ClientsContainer />, <TokensSearchContainer />, <ConfigContainer />];

class Body extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	activeElement: 0
	    }
	}

	componentDidMount() {

	}

	showMessagePopup () {
		this.props.actions.setShowErrorMessagePopup(false)
		this.props.actions.setErrorResponse(null)
	}

	render() {
		let drawerClasses = 'body-width'
		if (this.props.base.drawerOpen) {
		    drawerClasses = 'body-width open'
		}
		return (
			<div className={drawerClasses}>
				<BreadcrumbsContainer />
  				{activeElementsArray[this.props.base.selectedTab]}
  				{
					this.props.base.showSessionEndHandler
					? <SessionEndPopup />
		            : null
		        }
		        {
					this.props.base.showErrorMessagePopup
					? <ErrorMessagePopup closeMessagePopup={this.showMessagePopup.bind(this)} data={this.props.base.errorResponse} />
					: null
				}
				{
                    this.props.base.showActionResult
                    ? <ActionResultInfoPopup resultData={this.state} />
                    : null
                }
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        login: state.loginReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setShowErrorMessagePopup, setErrorResponse
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);